module.exports = __webpack_public_path__ + "img/gchess.5bf9a3a.webp";